<template>
  <article class="bg-modal-bg">
    <div class="flex flex-col">
      <ProductDetailPanel v-if="variant?.product?.type !== PRODUCT_TYPE.AUCTION" :variant="variant" />
      <ProductCategoryBreadcrumbs
        v-if="variant.product?.category"
        :categories="[ variant.product?.category ]"
        :base-route-code="baseRouteCode"
      >
        <BackButton :route-code="ROUTES.CODE.ADS" class-name="pr-5 lg:pr-10 text-light hover:underline" />
      </ProductCategoryBreadcrumbs>
      <div class="flex flex-col md:flex-row max-w-screen-xl" :style="{ 'margin-left': 'max(0px, calc(50vw - 640px))' }">
        <div class="md:w-1/2 pb-0 md:pb-5 px-5 md:px-3 py-5 md:pl-10">
          <ProductDetailGallery :variant="variant" class="mb-0 md:mb-10" />
          <ProductDetailInfoActions :variant="variant" position="outside" />
        </div>
        <div class="w-full md:w-1/2 px-5 md:px-3 pb-10 pt-0 md:pt-10">
          <ProductDetailInfo :variant="variant" class="w-full" @select:tab:comments="selectTabComments" />
        </div>
      </div>
      <SupplierAdsPanel :except-id="variant.id" :supplier="variant?.product?.supplier" />
      <RecommendPanel :except-id="variant.id" :category="variant?.product?.category" />
      <CataloguePanel v-if="variant?.cataloguePosts?.length" :posts="variant.cataloguePosts" />
    </div>
  </article>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { PRODUCT_TYPE } from "@utils/constants";
import BackButton from "@components/ui/back-button";
import ProductDetailGallery from "@components/product/product-details/product-detail-gallery";
import ProductDetailPanel from "@components/product/product-details/product-detail-panel";
import ProductDetailInfo from "@components/product/product-details/product-detail-info";
import ProductCategoryBreadcrumbs from "@components/category/product-category-breadcrumbs";
import SupplierAdsPanel from "@components/product/product-panel/supplier-ads-panel";
import RecommendPanel from "@components/product/product-panel/recommend-panel";
import CataloguePanel from "@components/catalogue/catalogue-panel";
import ProductDetailInfoActions from "@components/product/product-details/product-detail-info-actions";

const props = defineProps({
  variant: {
    type: Object,
    default: () => { }
  }
})

const { $eventBus } = useNuxtApp();

const baseRouteCode = computed(() => ({
    [PRODUCT_TYPE.OFFER]: ROUTES.CODE.OFFERS,
    [PRODUCT_TYPE.WANTED]: ROUTES.CODE.REQUESTS,
    [PRODUCT_TYPE.AUCTION]: ROUTES.CODE.AUCTIONS
})[props.variant?.product?.type] || ROUTES.CODE.OFFERS);

const selectTabComments = (id) => {
  if (id === props.variant.id) {
    $eventBus.emit('focus:input', 'comment');
  }
}

</script>
